import { render, staticRenderFns } from "./report-bottom.vue?vue&type=template&id=d63e2b24&scoped=true"
import script from "./report-bottom.vue?vue&type=script&lang=js"
export * from "./report-bottom.vue?vue&type=script&lang=js"
import style0 from "./report-bottom.vue?vue&type=style&index=0&id=d63e2b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63e2b24",
  null
  
)

export default component.exports